import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    recipientType: String,
    recipientId: Number
  }

  showRecipient(event) {
    event.preventDefault()
    
    const recipientType = this.recipientTypeValue
    const recipientId = this.recipientIdValue
    
    // Öffne Sidebar
    const sidebar = document.querySelector('[data-sidebar-target="sidebar"]')
    if (sidebar) {
      sidebar.classList.remove('hidden')
      sidebar.classList.add('lg:block')
    }
    
    // Lade Recipient-Details via Turbo Frame
    const sidebarFrame = document.getElementById('phonecalls-sidebar')
    if (sidebarFrame) {
      const url = new URL(window.location.href)
      url.searchParams.set('recipient_type', recipientType)
      url.searchParams.set('recipient_id', recipientId)
      sidebarFrame.src = url.toString()
    }
  }
}

